import React, { Component } from 'react';
import AppProvider from './context/context';
import './App.css';
import Me from './images/me.jpg';
import About from "./pages/about";
import Portfolio from "./pages/portfolio";
import Contact from "./pages/contact";
import ReactIcon from './logo.svg';
import { BrowserRouter, Route, Link, Switch } from "react-router-dom";

import LogoUnicarioca from './images/logo-unicarioca.jpg';
import LogoUP from './images/universo-profissional2.png';

import LogoRepassa from './images/repassa.png';
import LogoSellbie from './images/sellbie7.png';
import LogoAncine from './images/ancine2.png';

import MagnetFinder from './images/screen-magnet-finder-min.png';
import MinhaEncomenda from './images/screen-minha-encomenda-min.png';
import ExtMinhaEncomenda from './images/extensao-minha-encomenda-min.png';
import CovidDashboard from './images/screen-covid-dashboard-min.png';
import ArtMagazine from './images/screen-art-magazine-min.png';
import Flexbox from './images/screen-lorem-ipsum-flexbox-min.png';
import GeraLink from './images/gera-link-min.png';
import DocMagnetFinder from './images/doc-magnet-finder-min.png';
import MinhaEncomendaIntegracao from './images/minha-encomenda-integracao-min.png';
import EcommerceMinhaEncomenda from './images/minha-encomenda-ecommerce-min.png';
import MovieInfo from './images/movie-info-min.png';
import RaMC from './images/ram-min.png';
import TvPaga from './images/informe-ancine-min.png';

import TvPagaPDF from "./images/certificados/tv-paga.pdf";


class Main extends Component{
	constructor(){
		super()
		this.state = {
			mobileMaxWidth: 992,
			windowWidth: window.innerWidth, // além de ser utilizado na função de scroll da linha 198, pode ser utilizado em outros componentes
			language: "all",
			isIOS: "",
			formUrl: "https://formspree.io/f/xaylbggl",
			education: [
				{
					logotipo: LogoUnicarioca,
					altLogo: "logotipo do centro universitário carioca",
					nomeInstituicaoEnsino: "Centro Universitário Carioca, UNICARIOCA",
					nomeCurso: "Análise e Desenvolvimento de Sistemas",
					periodo: "2019 à 2022",
					local: "Rio de Janeiro, RJ",
				}, 
				{
					logotipo: LogoUP,
					altLogo: "logotipo do curso técnico universo profissional",
					nomeInstituicaoEnsino: "Universo Profissional, UP",
					nomeCurso: "Técnico em Montagem e Manutenção de Computadores",
					periodo: "2012 à 2013",
					local: "Rio de Janeiro, RJ",
				}, 
			],
			workExperience: [
				{
					nomeEmpresa: "Repassa",
					nomeCargo: "Analista de Engenharia de Software 2, Front-end",
					periodo: "2022 até o momento",
					descricao: `O Repassa é uma plataforma online de compra e venda de vestuário, calçados e acessórios da Lojas Renner S.A. 
					É considerado o maior brechó online do Brasil e opera no modelo gerenciado, ou seja, faz a curadoria e controle de qualidade das peças e toda a jornada do consumidor durante as transações.
					 Como Analista de Engenharia de Software 2, minha rotina inclui atividades como refinamento de requisitos,
					  análises detalhadas e elaboração de documentações. Além disso, participo ativamente na identificação e correção de problemas, 
					  propondo melhorias técnicas, seja em termos de performance ou de UI/UX, por exemplo. 
					  Desenvolvo funcionalidades no front-end priorizando boas práticas e realizando testes para garantir a qualidade do código.`,
					tecnologias: ["React JS","Next JS","Jest","GraphQL"],
					logotipo: LogoRepassa,
					altLogo: "logotipo do repassa",
				},
				{
					nomeEmpresa: "Sellbie",
					nomeCargo: "Desenvolvedor Júnior, Front-end",
					periodo: "2021 à 2022",
					descricao: "A Sellbie é uma empresa que tem como objetivo aumentar as vendas do varejo por meio de uma plataforma de CRM omnichannel. Atuei no suporte e no desenvolvimento de melhorias e novas funcionalidades para os aplicativos e a plataforma, além de contribuir ocasionalmente no back-end, trabalhando com APIs e procedures do banco de dados.",
					tecnologias: ["Css","jQuery","React JS","React Native"],
					logotipo: LogoSellbie,
					altLogo: "logotipo da sellbie",
				},
				{
					nomeEmpresa: "Agência Nacional do Cinema, ANCINE",
					nomeCargo: "Estagiário, Coordenação de Aquisição e Análise de Dados",
					periodo: "2019 à 2021",
					descricao: "A ANCINE é uma agência reguladora que tem como atribuições o fomento, a regulação e a fiscalização do mercado do cinema e do audiovisual no Brasil. Participei das atividades de coleta, análise e visualização de dados. Participei, por exemplo, do Informe de Mercado de Televisão Paga. Além das atividades citadas, também desempenhei atividades de front-end para criar telas com dashboards interativos para os setores interessados da agência.",
					tecnologias: ["R","R-Markdown","Python","SQL"],
					logotipo: LogoAncine,
					altLogo: "logotipo da ancine",
				},
			],
			portfolio: [
				{
					imagem: MinhaEncomenda,
					url: "https://www.minhaencomenda.me/",
					descricao: "Site e API criados para rastrear objetos dos Correios e também da Jadlog. O site possui cache para um melhor desempenho. No ar desde 2020. Projeto feito com HTML, CSS, jQuery e Flask - Python.",
					tecnologia: "python",
				},
				{
					imagem: MinhaEncomendaIntegracao,
					url: "https://minha-encomenda-ecommerce.netlify.app/",
					descricao: "Integração Minha Encomenda. Área de cadastro e login das lojas virtuais, onde os usuários podem editar as informações das páginas de rastreio. Feito com React JS no Front-End e Flask no Back-End (API + CRUD com SQLAlchemy).",
					tecnologia: "react",
				},
				{
					imagem: ExtMinhaEncomenda,
					url: "https://chrome.google.com/webstore/detail/minha-encomenda/cnacicmmmnkdepclkehggaeiimcjihoa?hl=pt-BR&authuser=0",
					descricao: "Extensão de navegador para rastrear objetos dos Correios. No ar desde 2020. Feito com JavaScript, HTML e CSS.",
					tecnologia: "javascript",
				},
				{
					imagem: GeraLink,
					url: "https://www.gera-link.com/",
					descricao: "Gerador e encurtador de links, gerador de QR Code e contador de cliques de URL. Feito com HTML, CSS, jQuery e Flask - Python.",
					tecnologia: "python",
				},
				{
					imagem: ArtMagazine,
					url: "https://herbertizidro.github.io/art-magazine/",
					descricao: "Site de revista fictícia, com seções de entrevistas, ensaios fotográficos e etc. Projeto desenvolvido com jQuery, HTML e CSS.",
					tecnologia: "javascript",
				},
				{
					imagem: Flexbox,
					url: "https://herbertizidro.github.io/flex-box-estudo/",
					descricao: "Exercício prático com Flexbox CSS. Site One Page para exibição de um produto fictício. Desenvolvido com HTML e CSS.",
					tecnologia: "javascript",
				},
				{
					imagem: MagnetFinder,
					url: "https://github.com/herbertizidro/magnet_finder",
					descricao: "Extensão de navegador para pesquisar magnet links de jogos, músicas e etc. Feito com JavaScript, HTML e CSS.",
					tecnologia: "javascript",
				},
				{
					imagem: RaMC,
					url: "https://github.com/herbertizidro/rick-and-morty-next-app",
					descricao: "Aplicativo web que exibe os personagens do desenho Rick and Morty. Permite buscar por um personagem e ver suas informações. Feito com Next JS.",
					tecnologia: "next",
				},
				{
					imagem: MovieInfo,
					url: "https://movieinfo-app.netlify.app/",
					descricao: "Aplicativo web que exibe informações sobre filmes e séries. Feito com React JS para praticar Context Api, React Router e Hooks. Utiliza uma API feita com Next JS.",
					tecnologia: "react",
				},
				{
					imagem: EcommerceMinhaEncomenda,
					url: "https://www.minhaencomenda.me/customize",
					descricao: "Integração Minha Encomenda. Página de rastreio customizada para lojas virtuais. Feito com HTML, CSS e Flask - Python.",
					tecnologia: "python",
				},
				{
					imagem: DocMagnetFinder,
					url: "https://herbertizidro.github.io/docs.magnetfinder/",
					descricao: "Documentação do código da extensão Magnet Finder. Desenvolvido com R-Markdown.",
					tecnologia: "r-lang",
				},
				{
					imagem: CovidDashboard,
					url: "https://github.com/herbertizidro/coronavirus_shiny_app",
					descricao: "Dashboard que exibe dados e notícias atualizadas sobre a pandemia da Covid-19 no Brasil. Feito com Shiny Dashboard - R.",
					tecnologia: "r-lang",
				},
				{
					imagem: TvPaga,
					url: TvPagaPDF,
					descricao: 'Informe de Mercado de Televisão Paga, da ANCINE. Como estagiário, auxiliei no tratameto e análise de dados com a linguagem de programação estatística "R".',
					tecnologia: "r-lang",
				},
			],
		}
	}
	
	componentDidMount(){
		
		/* verifica se o sistema do visitante é IOS(no IOS os svg da seção habilidades ficam bugados) */
		const IOS = [
			 'iPad Simulator',
			 'iPhone Simulator',
			 'iPod Simulator',
			 'iPad',
			 'iPhone',
			 'iPod',
			 'MacIntel'
		].indexOf(navigator.platform) !== -1;
			
		this.setState({ isIOS: IOS });
		/* obtém a largura da tela */
		window.addEventListener('resize', this.setState({ windowWidth: window.innerWidth }));

	}
	
	componentWillUnmount() {
		window.removeEventListener('resize', this.setState({ windowWidth: window.innerWidth }));
	}

	filterLanguage = e => this.setState({language: e.target.value});
	
	scrollTo = (id = "info") => {
		const element = document.getElementById(id);
		if(this.state.windowWidth <= this.state.mobileMaxWidth) element.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
	}
	
	render(){
	  return (
		<BrowserRouter>
			<div className="content container-fluid">
					<div className="row site">
						
						<div id="main" className="col-lg">
									
									<img id="my-photo200x200" alt="minha foto de perfil" width="200" height="200" className="mt-5 mb-3 rounded-circle img-responsive" style={{border: "2px solid white"}} src={Me}/>
									
									<div className="apresentacao row mb-2">
										<div className="col-lg text-white">
											<h4>Herbert Souza</h4>
											<h6>Desenvolvedor Front-end Pleno</h6>
											<a id="linkedin" href="https://github.com/herbertizidro" target="_blank" rel="noreferrer" aria-label="url do perfil no linkedin"><i className="fa fa-github"></i></a>&nbsp;&nbsp;&nbsp;
											<a id="github" href="https://www.linkedin.com/in/herbert-souza/" target="_blank" rel="noreferrer" aria-label="url do github"><i className="fa fa-linkedin-square"></i></a>
																					
											<div className="row mt-3 mb-2 text-white">
												<div className="col" id="menu-btn">
													
														<Link id="btn-menu-sobre" to="/" type="button" className="btn btn-sm btn-outline-light m-2 shadow-none" onClick={e => this.scrollTo()}>Sobre mim</Link>
														<Link id="btn-menu-portfolio" to="/portfolio" type="button" className="btn btn-sm btn-outline-light m-2 shadow-none" onClick={e => this.scrollTo()}>Portfólio</Link>
														<Link id="btn-menu-contato" to="/contact" type="button" className="btn btn-sm btn-outline-light m-2 shadow-none" onClick={e => this.scrollTo()}>Contato</Link>
													
												</div>
											</div>
										</div>
									</div>
							<footer className="footer-position text-white"><small>Feito com<img className="logo-react" src={ReactIcon} style={{width: "30px", cursor: "pointer"}} data-toggle="tooltip" data-placement="top" title="React JS" alt="icone react js" /></small></footer>
						</div>
						<div id="info" className="col-lg">
							
							<AppProvider.Provider value={{ state: this.state, scrollTo: this.scrollTo, filterLanguage: this.filterLanguage }}>
							
								<Switch>
									<Route exact path="/" component={About}/>
									<Route path="/portfolio" component={Portfolio}/>
									<Route path="/contact" component={Contact}/>
								</Switch>
								
							</AppProvider.Provider>
							
						</div>
					</div>
			</div>
		</BrowserRouter>
	  )

	}
}

export default Main;